import axios from "axios";
import { log } from "../../Helper";
async function getOrders(url, filterData) {
    const response = await axios.post(url, filterData);
    log(response);
    const orders = response.data;
    return orders;
}
export default getOrders;